import { render, staticRenderFns } from "./priceSettingInfo.vue?vue&type=template&id=6c00fe54&"
import script from "./priceSettingInfo.vue?vue&type=script&lang=js&"
export * from "./priceSettingInfo.vue?vue&type=script&lang=js&"
import style0 from "./priceSettingInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports